import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';
import LocalizedStrings from 'react-localization';
import ApplyInfo from '../containers/ApplyInfoContainer';
import ApplyForm from '../components/ApplyForm';
// import InsurancePayItems from '../components/InsurancePayItems'
import {MorePossibilitiesModule} from 'polisua-react-modules/index.esm';

function ApplyView(props) {
  useEffect(() => {
    if (localStorage.getItem('offers')) {
      props.addToDataLayer();
      window.scrollTo(0, 0);
    }
  }, []);

  const strings = new LocalizedStrings({
    ru: {
      main: 'Главная',
      insurance: 'Cтрахование',
      set: 'Оформить полис КАСКО',
    },
    ua: {
      main: 'Головна',
      insurance: 'Страхування',
      set: 'Оформити поліс КАСКО',
    },
  });

  if (localStorage.getItem('offers')) {
    return (
      <div>
        <section id="apply_page">
          <div className="container">
            <div className="title-block text-center">
              <h2>{strings.set}</h2>
            </div>
            <div className="apply-row row flex_j-space-between">
              <ApplyInfo locale={props.locale} />
              <ApplyForm locale={props.locale} addToDataLayer={props.addToDataLayer} />
            </div>
          </div>
        </section>
        <section id="polis-about">
          <div className="container">
            {/*<InsurancePayItems locale={props.locale} />*/}
            <MorePossibilitiesModule lang={props.locale === 'ua' ? 'uk' : 'ru'} />
          </div>
        </section>
      </div>
    );
  } else {
    return <Redirect to={props.locale === 'ua' ? '/uk/kasko' : '/kasko'} />
  }
}

export default withRouter(ApplyView);
